import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, bmRequestStatusHistroy } from '../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from '../../../models/admin';
import { outgoingBMRequest } from '../../../models/slakpi';
import { UtilityService } from '../../../services/utility.service';
import { BMApiService } from '../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../services/admin.service';
import { ToasterService } from '../../../toaster.service';

@Component({
  selector: 'app-outgoing-bm-request-master',
  templateUrl: './outgoing-bm-request-master.component.html',
  styleUrls: ['./outgoing-bm-request-master.component.css']
})
export class OutgoingBMRequestMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('requestStatusUpdateTemplate', { static: false }) requestStatusUpdateTemplate: TemplateRef<any>;
  @ViewChild('requestStatusUpdateHistroyTemplate', { static: false }) requestStatusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objPM: any = new benchmarkprogressmaster();
  objOutgoingRequest: any = new outgoingBMRequest();
  objStatusHistroy: any = new bmRequestStatusHistroy();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pfmType: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
    bmProgressTypeDDList: Object;
    division_data: Object;
  department_data: Object;
  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Awaiting Approval' }, { value: 3, text: 'Approved' }, { value: 4, text: 'On Hold' }, { value: 5, text: 'Rejected' }];
  userList: any;
    login_UserID: any;
    editID: any;
    searchText: string;
  histroyColumnDefinitions: Column[];
    bmRequestStatusHistroyDataSet: any[];
  dataHistroy: any;

  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  tenantUno: any;
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService,
    public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService,private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) { 
  this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
this.ValidateUserAccess();
  }
//Method used To Validate User Permission

ValidateUserAccess() {
  

  this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

  if (this.user.role == 'BM Champions')
    this.isBMChampion = true;
  if (this.user.role == 'BM Team')
    this.isBMTeam = true;
  if (this.user.role == 'BM Visitor')
    this.isBMVisitor = true;
  if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

  if (!this.isAdmin) {
    let userPermissionData = this.userService.getUserRights("Outgoing BM Request");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
  }

}
  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.loadOutgoingBMRequestMaster();
    this.getDepartments();
    this.getDivisions();

  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  


  setGridOutgoingBMRequestMasterDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'division', name: 'Division', field: 'division', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'department', name: 'Department', field: 'department', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'department', 'department'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'bmChampion', name: 'BM Champion', field: 'bmChampion', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bmChampion', 'bmChampion'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'entityCategory', name: 'Entity Category', field: 'entityCategory', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'entityCategory', 'entityCategory'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'entityType', name: 'Entity Type', field: 'entityType', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'entityType', 'entityType'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'entity', name: 'Entity', field: 'entity', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'entity', 'entity'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'contactDetails', name: 'Contact Details', field: 'contactDetails', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'contactDetails', 'contactDetails'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 20,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Approved')
            return '<span  class="status-area status-green">Approved</span>';
          else if (data.status == 'Awaiting Approval')
            return '<span  class="status-area status-orange">Awaiting Approval</span>';
          else if (data.status == 'On Hold')
            return '<span  class="status-area status-yellow">On Hold</span>';
          else if (data.status == 'Rejected')
            return '<span  class="status-area status-red">Rejected</span>';
          else if (data.status == 'Draft')
            return '<span  class="status-area status-gray">Draft</span>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objOutgoingRequest = rdata;
                this.selTab = true;

              

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objStatusHistroy.status = rdata.status;




                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.requestStatusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMRequestStatusHistroy();
                this.modalRef = this.modalService.show(
                  this.requestStatusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteOutgoingBMRequestMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }

 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadOutgoingBMRequestMaster() {
    this.columnDefinitions = [];
    this.spinner.show();
    let inpValue = new outgoingBMRequest();
    inpValue.languageUno = 1033;
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restBMApi.getOutgoingBMRequestMaster(inpValue)
      .subscribe(data => {
        
        this.searchText = '';
        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              incidentNo: this.data[i].incidentNo,
              prNumber: this.data[i].prNumber,
              division: this.data[i].division,
              divisionUno: this.data[i].divisionUno,
              department: this.data[i].department,
              departmentUno: this.data[i].departmentUno,
              bmChampion: this.data[i].bmChampion,
              entityCategory: this.data[i].entityCategory,
              entityType: this.data[i].entityType,
              entity: this.data[i].entity,
              contactDetails: this.data[i].contactDetails,
              justification: this.data[i].justification,
              bmSubject: this.data[i].bmSubject,
              purpose: this.data[i].purpose,
              reqName: this.data[i].reqName,
              designation: this.data[i].designation,
              teamLeader: this.data[i].teamLeader,
              mobileno: this.data[i].mobileno,
              ownerPRNumber: this.data[i].ownerPRNumber,
              status: this.data[i].status,
              enteredBy: this.data[i].enteredBy,
              enteredOn: this.data[i].enteredOn,

            };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridOutgoingBMRequestMasterDefn();
        }
        else {
          this.setGridOutgoingBMRequestMasterDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objOutgoingRequest = new outgoingBMRequest();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.AddEditOutgoingBMRequestMaster(this.objOutgoingRequest)
    }
  }

  AddEditOutgoingBMRequestMaster(data1: any) {
    
   
    //if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
    //  Swal.fire('Error', 'Duplicates are not allowed', 'warning');
    //  return false;
    //}

    let obj = new outgoingBMRequest();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.divisionUno = this.objOutgoingRequest.divisionUno.toString()
    obj.departmentUno = this.objOutgoingRequest.departmentUno
    obj.bmChampion = this.objOutgoingRequest.bmChampion;
    obj.entityCategory = this.objOutgoingRequest.entityCategory;
    obj.entityType = this.objOutgoingRequest.entityType;
    obj.entity = this.objOutgoingRequest.entity;
    obj.contactDetails = this.objOutgoingRequest.contactDetails;
    obj.justification = this.objOutgoingRequest.justification;
    obj.bmSubject = this.objOutgoingRequest.bmSubject;
    obj.purpose = this.objOutgoingRequest.purpose;
    obj.reqName = this.objOutgoingRequest.reqName;
    obj.mobileno = this.objOutgoingRequest.mobileno;
    obj.status = (this.editID != null && this.editID != undefined) ? this.objOutgoingRequest.status:'Draft';
    obj.incidentNo = '0';
    obj.prNumber = '0';
    obj.ownerPRNumber = '0';
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    this.restBMApi.addEditOutgoingBMRequestMaster(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Item Saved.');
            setTimeout(() => {
              this.objOutgoingRequest = new outgoingBMRequest();
              this.spinner.hide();
              this.loadOutgoingBMRequestMaster();
              this.modalRef.hide();
            }, 500);
           
          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
   
  }
  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    let progressTypeDublicate = [];
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      progressTypeDublicate=this.data.filter(a => a.bmProgressTypeUno == parseInt(this.objPM.bmProgressTypeUno));
      progressTypeDublicate.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.bmProgressName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      

      });

      return rtnValue;
    }
  }


  DeleteOutgoingBMRequestMaster(data1: any) {
    
    let obj = new outgoingBMRequest();
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    this.restBMApi.deleteOutgoingBMRequestMaster(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Item Deleted Successfully.');
          this.spinner.hide();
          this.loadOutgoingBMRequestMaster();
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }


       
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objOutgoingRequest = new outgoingBMRequest();
      this.pageAction = 'add';
    }, 300);


  }
  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.department && a.department.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bmChampion && a.bmChampion.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.entityCategory && a.entityCategory.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.entityType && a.entityType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.entity && a.entity.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.contactDetails && a.contactDetails.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.data;
  }

  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateBMRequestStatus(this.objStatusHistroy);
    }
  }
  updateBMRequestStatus(data1: any) {
    



    let obj = new bmRequestStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments : '';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.flag = 'outbmrequest';
    this.restBMApi.updateBMRequestStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Status Updated.');
          setTimeout(() => {
            this.objStatusHistroy = new bmRequestStatusHistroy();
            this.spinner.hide();
            this.loadOutgoingBMRequestMaster();
            this.modalRef.hide();
          }, 500);

        }
        else {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  setGridBMRequestStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 100,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'enteredBy', name: 'Action By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredBy', 'enteredBy'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'enteredOn', name: 'Action Date', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }
  loadBMRequestStatusHistroy() {
    this.histroyColumnDefinitions = [];
    this.spinner.show();
    let inpValue = new bmRequestStatusHistroy();
    inpValue.flag = 'outbmrequest';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restBMApi.getBMRequestStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            reqNo: this.dataHistroy[i].reqNo,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.bmRequestStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMRequestStatusHistroyDefn();
        }
        else {
          this.setGridBMRequestStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
}
